import { render, staticRenderFns } from "./UserAssignRole.vue?vue&type=template&id=98860120&"
import script from "./UserAssignRole.vue?vue&type=script&lang=js&"
export * from "./UserAssignRole.vue?vue&type=script&lang=js&"
import style0 from "./UserAssignRole.vue?vue&type=style&index=0&id=98860120&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports